import { render, staticRenderFns } from "./score-card.vue?vue&type=template&id=4122312a&scoped=true"
import script from "./score-card.vue?vue&type=script&lang=js"
export * from "./score-card.vue?vue&type=script&lang=js"
import style0 from "./score-card.vue?vue&type=style&index=0&id=4122312a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4122312a",
  null
  
)

export default component.exports